module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kh-La.aa99b1f8.png";